import styled from "styled-components";
const TutorialsPageDisplay = styled.div`
	// my css here
`;	export default TutorialsPageDisplay;
